import type { IFormProps } from './Form'

import { styled } from '@linaria/react'

export const FormSC = styled.form<
  Omit<IFormProps, 'width' | 'height'> & {
    blockWidth?: string
    blockHeight?: string
  }
>`
  display: flex;
  width: ${({ blockWidth }) => blockWidth ?? 'initial'};
  height: ${({ blockHeight }) => blockHeight ?? 'initial'};
  flex-direction: ${({ direction }) => direction ?? 'initial'};
  align-items: ${({ alignItems }) => alignItems ?? 'initial'};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'initial'};
  flex-wrap: ${({ wrap }) => wrap ?? 'initial'};
`
